import Vue from 'vue';
import Vuex from 'vuex';
import { nodeenv } from '@/config';
import * as common from './common';
import * as memberSource from './memberSource';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: nodeenv !== 'production',
  modules: {
    common, memberSource
  }
});
